<template>
  <b-container class="bv-example-row">
    <list-table
      :url="url"
      title="لیست لینک های پرداخت هدفدار"
      :fields="fields"
      :params="params"
      :btns="btns"
    ></list-table>
  </b-container>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../components/table";
import persianDate from "../../helpers/persianDate";

export default {
  name: "GoalLinkList",
  data() {
    return {
     
      url: "goal-link",
      params: [
        {
      label: "از تاریخ",
      field: "dateFrom",
      type: "date-picker",
      },
      {
      label: "تا تاریخ",
      field: "dateTo",
      type: "date-picker",
      },
      {
      label: "وبسایت",
      field: "website_name",
      type: "text",
      },
      {
      label: "عنوان لینک",
      field: "title",
      type: "text",
      },
      {
      label: "مبلغ (ریال)",
      field: "amount",
      type: "number",
      },
      ],

      fields: [
        {
          key: "id",
          label: "کد لینک",
        },
        {
        key: "website_name",
        label: "وبسایت"
        },
        {
          key: "title",
          label: " عنوان لینک",
        },
        {
          key: "amount",
          label: "مبلغ (ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "created_at",
          label: "تاریخ ایجاد",
          formatter(value, key, item) {
            return persianDate.getDateByFormat(value);
          },
        },
        {
        key: "description",
        label: "توضیحات"
        },
         {
          key: "sumCost",
          label: "مبلغ جمع آوری شده(ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
         {
          key: "btns",
          label: "عملیات",
        },
      ],
       btns: [
        {
          title:'لیست تراکنش ها',
          icon: "eye",
          handler: (t) => {
            this.$router.push("goal-link-transaction/" + t.id);
          },
        },
       
      ],
    };
  },
  components: {
    "list-table": TableShowData,
  },
 
  methods: {
 
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "لینک های پرداخت هدفدار" }]);
  },
};
</script>

